import { createLDReactProvider, type LDContext } from '@launchdarkly/react-sdk';
import { FC, ReactNode, useState } from 'react';

export const BOOTSTRAP_KEY = 'ld:bootstrap'; // JSON: { "flagA": false, "flagB": true }
export const CONTEXT_KEY = 'ld:context'; // JSON: LD context object

function getBootstrap(): Record<string, unknown> | undefined {
  try {
    const raw = window.localStorage.getItem(BOOTSTRAP_KEY);
    return raw ? JSON.parse(raw) : undefined;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(
      `Failed to parse ${BOOTSTRAP_KEY} from local storage during test:`,
      e,
    );
    return undefined;
  }
}

function getContext(): LDContext {
  try {
    const raw = window.localStorage.getItem(CONTEXT_KEY);
    if (raw) {
      return JSON.parse(raw);
    }
  } catch {
    // Do nothing, will fallback to default context
  }

  // Sensible default context for Backstage guest runs
  return { kind: 'aura-portal-user', key: 'guest' };
}

export const LDTestingProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [Provider] = useState(() =>
    createLDReactProvider('test-ci', getContext(), {
      bootstrap: getBootstrap(),
      ldOptions: {
        streaming: false,
        sendEvents: false,
      },
    }),
  );

  return <Provider>{children}</Provider>;
};
